import React from "react";
import "./MyNFTCollection.css";
import MyNFTsImage from "./assets/MyNFTs.png";
import { useNavigate } from "react-router-dom";

function MyNFTCollection() {
  const navigate = useNavigate();
  const NFTsCollectionClick = () => {
    navigate("/NFT");
    window.scrollTo(0, 0);
  };

  return (
    <section className="my-nfts-collection-container">
      <div className="NFTs-image">
        <div className="game-image">
          <img
            src={MyNFTsImage}
            onClick={NFTsCollectionClick}
            alt="NFTS"
            className="image"
          />
        </div>
      </div>

      <div className="NFTs-describe">
        <h1 className="title">NFT</h1>
        <div className="showmore-button">
          <p className="button" onClick={NFTsCollectionClick}>
            {"More"}
          </p>
        </div>
      </div>
    </section>
  );
}

export default MyNFTCollection;
